import React from 'react'
import { withRouter } from 'react-router-dom'
import { datadogLogs } from '@datadog/browser-logs'

import { hasAccessToThis } from 'services/Utilities'
import { t } from 'translations'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, err: null }
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidMount() {
    // Listen on history change to reset error page
    const unlisten = this.props.history.listen(() => {
      if (this.state.hasError) this.setState({ hasError: false })
    })

    // Save history unlistener
    this.setState({ ...this.state, history: { unlisten } })
  }

  // Remove listener for history changes
  componentWillUnmount() {
    if (this.state.history && this.state.history.unlisten) this.state.history.unlisten()
  }

  componentDidCatch(err) {
    this.setState({ ...this.state, err })
    datadogLogs.logger.error(err.message, undefined, err)
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <tr className="table-warning">
          <td colSpan="100">
            <i className="fas fa-explamation-triangle mr-1" />
            {t('ROW_DATA_ERROR')} <b>{hasAccessToThis('isMeringoAdmin') && this.state.err ? this.state.err.message : null}</b>
            <div>{hasAccessToThis('isMeringoAdmin') ? <small>{t('ROW_DATA_ERROR_ID', { _id: this.props._id })}</small> : null}</div>
          </td>
        </tr>
      )
    }

    return this.props.children
  }
}

export default withRouter(ErrorBoundary)
